<template>
  <div>
    <Popup
      :zIndex="99"
      :raduis="false"
      :title="gettext('选择城市')"
      v-model="show"
      @cancel="close"
      :ratio="90"
      v-if="visible"
    >
      <city-picker
        ref="picker"
        :cityData="cityData"
        @cityChange="cityChange"
        :num="num"
      />
    </Popup>
    <Popup
      :zIndex="99"
      :raduis="false"
      :title="gettext('选择商圈')"
      v-model="show"
      :hideTilte="true"
      @cancel="close"
      :ratio="90"
      cancel-txt=""
      confirmTxt=""
      v-else
    >
      <area-tree
        :options="areaData"
        @areaChange="areaChange"
        @cityPopupShow="cityPopupShow"
      />
      <div class="area-picker_bottom">
        <rich-button
          class="area-picker-btn"
          :primary="true"
          :disabled="!areacheckedIds.length > 0"
          @click="confirmAreaChecked"
          >确定</rich-button
        >
      </div>
    </Popup>
  </div>
</template>
<script>
import { Popup } from '@/formily/src'
import { mapActions, mapMutations, mapState } from 'vuex'
import CityPicker from './cityPicker.vue'
import AreaTree from './areaTree.vue'
const namespace = 'bizoppV2'
export default {
  name: 'cityAreaPicker',
  components: { CityPicker, Popup, AreaTree },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      cityData: [],
      visible: true,
      // areaData: [],
      areacheckedIds: [],
      num: 0,
      firstEnterPage: false
    }
  },
  computed: {
    ...mapState('bizoppV2', [
      'cityIdsWithAuth',
      'commonAreaChecked',
      'commonCityChecked'
    ]),
    ...mapState(namespace, {
      commnoCityAreaTree: (state) => state.commnoCityAreaTree || [],
      allFilterParams: (state) => state.allFilterParams
    }),
    areaData() {
      const { children = [] } = this.commnoCityAreaTree.find((item) => {
        return item.id === this.commonCityChecked.value
      })
      return children
    }
  },

  created() {
    this.getCommonAreaTreeByTab()
  },
  mounted() {},
  watch: {
    // show(v) {
    //   if (!v) {
    //     if (this.commonCityChecked.value) {
    //       this.visible = true
    //     } else {
    //       this.visible = false
    //     }
    //   } else {
    //     this.areacheckedIds = this.commonAreaChecked
    //     this.visible = false
    //   }
    // }
    show: {
      immediate: true,
      handler(v) {
        console.log(this.areacheckedIds, 'AAAAA')
        this.areacheckedIds = this.commonAreaChecked
        if (!v) {
          if (this.commonCityChecked.value) {
            this.visible = false
          } else {
            this.visible = true
          }
        }
      }
    }
  },
  methods: {
    cityPopupShow() {
      this.visible = true
    },
    isFirstTimeEnter() {
      // const isExistinVuex =
      //   this.commonAreaChecked.length && this.commonCityChecked
    },
    ...mapMutations(namespace, [
      'updateCommonCityChecked',
      'updateCommonAreaChecked',
      'updateAllFilterParams',
      'updateCityIdWithAuth',
      'updateCommonAreaChecked'
    ]),
    ...mapActions(namespace, ['getCityByPoi', 'getCommonAreaTree']),

    // 获取城市商圈的数据
    async getCommonAreaTreeByTab() {
      await this.getCommonAreaTree()
      await this.getCityOptions()
    },
    // 获取城市数据
    getCityOptions() {
      if (this.commnoCityAreaTree.length) {
        let citydata = []
        this.commnoCityAreaTree.map((item) => {
          citydata.push({
            label: item.label,
            value: item.id
          })
        })
        this.cityData = this.sortCitydata(citydata)
      }
    },
    sortCitydata(cityData) {
      // 根据英文首字母进行排序
      cityData.sort((a, b) => {
        return (a.label + '').localeCompare(b.label + '')
      })
      return cityData
    },
    // 选择城市后出商圈选择数据和弹层
    cityChange(val, ...rest) {
      if (!val) return
      this.visible = false
      // const data = this.commnoCityAreaTree.find((item) => {
      //   return item.id === val
      // })
      // this.areaData = data.children
    },
    areaChange(val) {
      this.areacheckedIds = val
      // this.updateCommonAreaChecked(val)
    },

    close(v) {
      // this.updateCityIdWithAuth({}) // 清空城市
      // this.updateCommonAreaChecked([]) // 清空商圈

      this.$emit('cancel')
    },
    confirm() {
      this.updateCommonAreaChecked(this.areacheckedIds)
      this.$emit('cancel')
    },
    // 商圈选择确认
    confirmAreaChecked() {
      this.updateCommonAreaChecked(this.areacheckedIds)

      this.updateAllFilterParams({
        ...this.allFilterParams,
        commnoAreaCheckedIds: this.areacheckedIds
      })
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
.area-picker_bottom {
  padding: 20px 24px 40px 24px;
  background: #ffffff;
  box-sizing: content-box;
  box-shadow: 0 12px 80px 0 rgba(0, 0, 0, 0.08);
  border-radius: 0 0 12px 12px;
  position: fixed;
  bottom: 0;
  z-index: 100;
  .area-picker-btn {
    width: calc(100vw - 48px);
  }
}
</style>